export enum EAuthRoutes {
    LOGOUT = '/logout',
    USER_INFO = '/userInfo',
    GET_TWO_FA_CODE = '/get2faCode',
    GET_TWO_FA_CONFIG = '/use2fa',
    GET_TWO_FA_CODE_VALIDITY = '/get2faCodeValidity',
    VALIDATE_TWO_FA = '/verify2fa',
    CHANGE_PASSWORD = '/changePassword',
    CHANGE_PASSWORD_SETTINGS = '/change-password-settings',
    PROFILE = '/security/profile',
    AUTHENTICATION = '/security/authentication',
    MICROSERVICE_TOKEN = '/administration.security/microservices-token',
    GET_SESSION_ID = '/get-session-id',
}
